import * as auth from '../actions/auth.actions';

const INITIAL_STATE = {
  authenticated: false,
};

export function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case auth.AUTH_SUCCESSFUL:
      return {
        authenticated: true,
      };
    case auth.AUTH_FAILED:
      return {
        authenticated: false,
      };
    default:
      return state;
  }
}

export const isAuthenticated = state => state.authenticated;
